export default new class PromoSlider {
    constructor() {
        this.slider = '.fs-promo-slider';

        if (!document.querySelector(this.slider)) return;

        this.sliderList = '.fs-promo-slider--list';

        this.init();
    }

    init() {
        $(this.sliderList).slick({
            infinite: true,
            dots: true,
            accessibility: false,
            arrows: false,
            autoplay: true,
        })
    }
}